import type { FaireProductEntity } from "../../entity_types/product";

export const p_t6yjezsw5d: FaireProductEntity = {
  token: "p_t6yjezsw5d",
  type: "product",
  name: "Adjustable Shell Ring Pearl Color Open Stackable S5P895",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/965f3683db34c10138e037fdfe4182081394e46822378cece1f55baf04e6d3c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/899f1fe1f7d96c173c21de689f4c490296dc6d0565641f7dfd04855d988a64ec.jpeg",
    "https://cdn.faire.com/fastly/93776643ebdb065df2451810982a1ef6b431c3072d4332acf5a90416589c22ac.jpeg",
    "https://cdn.faire.com/fastly/a3ac27ce24cf79e943e9ff1b53ffde666d2458ecc9e770d36c2f45d2d81493c0.jpeg",
    "https://cdn.faire.com/fastly/e16db7303d4273eb9cb5419e0ccb19c80fc8d0bf2954118c0f5bc179853f18df.jpeg",
  ],
  priceDollars: 12.44,
  description:
    "Material:\n Copper (Electroplated)\n\n Weight:\n 9g\n\n Package:\n Single Piece\n\n Feature:\n Elegant Pearl Iridescent Shell Color\n Adjustable Open Ring Design (One Size Fits Most)\n Lightweight and Comfortable for Daily Wear\n Minimalist and Light Luxury Style\n Versatile Stacking Ring for Any Finger\n Perfect for Adding a Subtle, Natural Touch\n\n Note:\n The open design allows for a flexible fit. Due to the electroplating process, color may have slight variations, enhancing its unique shell-like appearance.",
  tags: [],
  msrpDollars: 24.89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:08.318Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
